// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__OHlgp","left":"InfoRow_left__BJvIU"};